// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__bGfN9","rotation":"Loader_rotation__V17Ew"};